import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';

export default function StoreSwitchModal({
  storeName = '',
  isOpen = false,
  isProcessing = false,
  isValidating = false,
  isSwitching = false,
  onClose = () => {}
}) {
  const isLoading = isValidating || isSwitching;
  return (
    <UiKit.Modal
      centered
      isOpen={isOpen}
      onClose={onClose}
      isProcessing={isProcessing}
      contentClassName={styles.modal}
    >
      <UiKit.Modal.Body>
        <If test={isLoading}>
          <div className="d-flex align-items-center">
            <i className="fas fa-spin fa-spinner" />
            <span className="ml-3">
              {isValidating ? (
                'Verifying access...'
              ) : isSwitching ? (
                <>
                  Switching to <strong>{storeName}</strong>
                </>
              ) : null}
            </span>
          </div>
        </If>
      </UiKit.Modal.Body>
    </UiKit.Modal>
  );
}
